import styled from 'styled-components';
import { colors, fontSizes } from '../styles';

export const Quote = styled.q`
  font-size: ${fontSizes.quote.fontSize};
  line-height: ${fontSizes.quote.lineHeight};
  color: ${colors.midnightBlack};
`;
